// extracted by mini-css-extract-plugin
export const sectionSpacing = "nav-menu-module--section-spacing--3eP46";
export const rowSpacing = "nav-menu-module--row-spacing--zy5C-";
export const rowSpacingSml = "nav-menu-module--row-spacing-sml--2G5XR";
export const navBar = "nav-menu-module--navBar--2lcdA";
export const menuItems = "nav-menu-module--menuItems--2f_Uq";
export const item = "nav-menu-module--item--Gw2zb";
export const navLink = "nav-menu-module--navLink--3wyeW";
export const mainLink = "nav-menu-module--mainLink--1DV7N";